import React from "react";
import { CloseIcon } from "../../../assets/icons";

interface DescriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  description: string;
}

const DescriptionModal = ({
  isOpen,
  onClose,
  description,
}: DescriptionModalProps) => {
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isOpen) return null;
    // Close the modal only if clicking on the overlay
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4 z-50 bg-black bg-opacity-50"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white w-full md:max-w-[400px] max-w-[380px] p-4 rounded-lg shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex">
          <h1 className="flex-1 xl:text-[20px] md:text-[19px] text-[18px] font-bold text-gray-800 mb-2">
            Project description
          </h1>
          <div
            onClick={onClose}
            className="flex justify-end mb-[-3em] cursor-pointer"
          >
            <CloseIcon />
          </div>
        </div>
        <p className="xl:text-[16px] md:text-[15px] text-[14px] mb-5">
          {description}
        </p>
      </div>
    </div>
  );
};

export default DescriptionModal;
